import * as React from "react";

export function CablePDIcon(props: React.SVGProps<SVGSVGElement>) {
  const color = props.color || "currentColor";
  return (
    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.379 90.231" {...props}>
      <path fill="none" d="M-1-1h582v402H-1z" />
      <g>
        <path
          fill={color}
          fillRule="evenodd"
          d="M42.52 0A42.52 42.52 0 000 42.52a42.52 42.52 0 0042.52 42.519A42.52 42.52 0 0085.039 42.52 42.52 42.52 0 0042.52 0zm0 7.584a14.173 14.173 0 0114.173 14.174A14.173 14.173 0 0142.52 35.932a14.173 14.173 0 01-14.174-14.174A14.173 14.173 0 0142.52 7.584zM24.205 38.73a14.173 14.173 0 0112.609 7.084 14.173 14.173 0 01-5.189 19.362 14.173 14.173 0 01-19.359-5.19 14.173 14.173 0 015.187-19.359 14.173 14.173 0 016.752-1.897zm35.627.014a14.173 14.173 0 017.754 1.883 14.173 14.173 0 015.189 19.361 14.173 14.173 0 01-19.361 5.188 14.173 14.173 0 01-5.187-19.362 14.173 14.173 0 0111.605-7.07z"
        />
      </g>
    </svg>
  );
}
